import { Navigate } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import authService from '../../services/auth';

export const goToHrisUrl = async () => {
    const hrisUrl = sessionStorage.getItem('hrisUrl') || '';
    setTimeout(() => { window.location.href = hrisUrl; }, 5000);
};

const PrivateRoute = ({ children, redirectTo, requiredLicense }) => {
    let err = '';
    if (!authService.isLoggedIn()) {
        err = 'You are not logged in';
    }
    if (requiredLicense) {
        if (!authService.validateLicense(requiredLicense)) {
            err = 'You do not have the required access';
        }
    }

    if (err) {
        toastr.error('Logging in', err);
        if (process.env.NODE_ENV === 'production') {
            goToHrisUrl();
            return <></>;
        }

        return <Navigate to={redirectTo} />;
    }

    return children;
};

export default PrivateRoute;
